<template>
  <!--MTBF-->
  <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{ title }}</div>
      <div id="mtbfechart" style="height: 100%; width: 100%"></div>
    </div>
  </dv-border-box-13>
</template>

<script>
export default {
  name: "andon-right",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    mtbf: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle: {
      type: String,
      default: function () {
        return "MTBF";
      },
    },
  },
  data() {
    return {
      title: this.headTitle,
      mtbfs: this.mtbf,
      platosMtbf: undefined,
    };
  },
  watch: {
    mtbf: {
      handler: function (val, oldVal) {
        this.mtbfs = val;
        this.mtbfEchart();
      },
      deep: true,
    },
  },
  mounted() {
    var _this = this;
  },
  methods: {
    mtbfEchart() {
      var _this = this;
      var echart = this.$echarts.init(document.getElementById("mtbfechart"));
      let daset = [];
      let daval = [];
      let falt = [];
      var dataSet = _this.mtbfs;

      dataSet.forEach((m) => {
        var count = m["issueCount"];
        var reported = m["reported"];
        var runTimes = m["runTimes"];
        var fish = m["fish"];
        var devCount = m["devCount"];
        var data = "0";
        if (count > 0) {
          var mtbf =
            (runTimes  / (1000 * 60) / count);
          data = mtbf.toFixed(2);
        }
        daset.push(m["period"] + "月");
        daval.push(data);
        falt.push(parseInt(m["kpi"]));
      });

      var option = {
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        grid: {
          bottom: "35",
          top: -60,
          x: 50,
          y: -40,
        },
        legend: {
          data: ["MTBF"],
          textStyle: {
            color: "#ffffff",
          },
        },
        xAxis: [
          {
            axisTick: {
              show: false,
            },
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: daset,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              interval: 0,
              rotate: 40,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value} m",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: 12,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            color: ["#3398DB"],
            name: "实际",
            type: "bar",
            data: daval,
          },
          {
            name: "目标",
            type: "line",
            data: falt,
            smooth: true,
            itemStyle: {
              normal: {
                label: {
                  show: false, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#FFF",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      echart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        echart.resize();
      });

      if (_this.platosMtbf) {
        clearInterval(_this.platosMtbf);
      }

      var index = 0; //显示tooltip,播放所在下标
      _this.platosMtbf = setInterval(function () {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= daset.length) {
          index = 0;
        }
      }, 2000);
    },
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.2rem 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/mtbf.vue